import type { NuxtApp } from 'nuxt/app'

// During SSR, forwards the visitor IP to the API so it rate limits each visitor separately
// instead of the whole site. server/middleware/visitor-ip.ts puts the visitor IP into the
// incoming X-Forwarded-For. Takes nuxtApp instead of using composables because ofetch
// re-runs onRequest on a retry outside the Nuxt context.
export function visitorIpHeaders(nuxtApp: NuxtApp): Record<string, string> {
  if (import.meta.client) {
    return {}
  }

  const visitorIp = nuxtApp.ssrContext?.event.node.req.headers['x-forwarded-for']

  return typeof visitorIp === 'string' && visitorIp ? { 'X-Forwarded-For': visitorIp } : {}
}
